import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import removeKeys from '../utils/removeKeys';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import PropTypes from 'prop-types';

/**
  Button is a simple component that will render either the title or child objects
  passed by props.
 **/
class Button extends React.Component {
  static displayName = 'Button';
  static propTypes = {
    /** Child nodes to render inside button. */
    children: PropTypes.node,
    /** CSS Modlues Object */
    classes: PropTypes.shape({
      /** Main style for the button. */
      button: PropTypes.string,
      /** Secondary style applied based on button kind. */
      primary: PropTypes.string,
      /** Secondary style applied based on button kind. */
      secondary: PropTypes.string,
      /** Secondary style applied based on button kind. */
      disabled: PropTypes.string,
      /** Secondary style applied based on button kind. */
      link: PropTypes.string
    }),
    /** Displays as button text. */
    title: PropTypes.node,
    /** Disabled prop and style key for button */
    disabled: PropTypes.bool,
    /** Callback function. */
    onClick: PropTypes.func,
    /** Callback function. */
    onMouseOver: PropTypes.func,
    /** Callback function. */
    onMouseOut: PropTypes.func,
    /** Sets html button property. */
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    /** Changes style applied to button. 'primary', 'secondary', 'disabled', 'button', 'link' or other */
    kind: PropTypes.string,
    /** Breakpoint Class to be added **/
    breakPoint: PropTypes.oneOf([
      'mediaSmall',
      'mediaMedium',
      'mediaLarge',
      'mediaAll'
    ]),
    forwardedRef: PropTypes.object,
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Main style for the button. */
      button: PropTypes.object,
      /** Secondary style applied based on button kind. */
      primary: PropTypes.object,
      /** Secondary style applied based on button kind. */
      secondary: PropTypes.object,
      /** Secondary style applied based on button kind. */
      disabled: PropTypes.object,
      /** Secondary style applied based on button kind. */
      link: PropTypes.object
    })
  };

  constructor(props) {
    super(props);
  }

  focus = () => {
    if (this.button) this.button.focus();
  };

  render() {
    const {
      children,
      disabled,
      kind = 'primary',
      type = 'button',
      title,
      breakPoint,
      forwardedRef,
      ...rest
    } = removeKeys(this.props, ['classes']);
    return (
      <button
        {...rest}
        ref={forwardedRef || (c => (this.button = c))}
        {...resolve(
          this.props,
          'button',
          kind,
          disabled ? 'disabled' : null,
          breakPoint
        )}
        {...resolveTestId(this.props)}
        disabled={disabled}
        title={title}
        type={type}
      >
        {children || <span>{title}</span>}
      </button>
    );
  }
}

export default Button;
